import { Button, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';

import { MembersCsvDeactivateModal } from '@/imports/ui/admin/components/people/MembersCsvDeactivateModal';
import { UploadIcon } from '@/imports/ui/chakra/customIcon/UploadIcon';

export const BulkArchiveCsvButton: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Button
        variant="outline"
        colorScheme="red"
        borderColor="red.500"
        onClick={onOpen}
      >
        <UploadIcon mr="2" height="24px" width="28px" mt="-5px" />
        Bulk Archive
      </Button>
      <MembersCsvDeactivateModal open={isOpen} onClose={onClose} />
    </>
  );
};
